import maInputBtn from '@/components/input/modules/btn'

/**
 * @module
 * @name toggleButton
  */
export default {
  name: 'toggleButton',
  components: {
    maInputBtn
  },
  /**
   * @property {Array} options Array of options. Option contain key and value.
   */
  props: {
    options: {
      type: Array,
      required: true,
      default: []
    }
  },
  data: function() {
    return {
      optionSelected: null
    }
  },
  computed: {
    defaultOption() {
      if (this.options && this.options.length > 0) {
        return this.options[0].key
      }

      return null
    }
  },
  methods: {
    handleButtonClick(keySelected) {
      this.optionSelected = keySelected
      this.$emit('selected', this.optionSelected)
    },

    isChecked(key) {
      return key === this.optionSelected
    }
  },

  mounted() {
    this.optionSelected = this.defaultOption
  }
}
